var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoorsLockedMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6,37V22.6572266c0-0.8017578,0.3120117-1.5556641,0.878418-2.1220703L9.4136353,18H36v4h2V7c0-1.6542969-1.3457031-3-3-3 H22.2426758c-1.0678711,0-2.0722656,0.4160156-2.8286133,1.171875L5.4643555,19.1210938 C4.5200195,20.0654297,4,21.3212891,4,22.6572266V37c0,1.6542969,1.3457031,3,3,3h19v-2H7C6.4487305,38,6,37.5517578,6,37z  M20.828125,6.5859375C21.206543,6.2080078,21.7089844,6,22.2426758,6H35c0.5512695,0,1,0.4482422,1,1v9H11.4137573 L20.828125,6.5859375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,32h-1v-3c0-2.7568359-2.2431641-5-5-5s-5,2.2431641-5,5v3h-1c-1.6542969,0-3,1.3457031-3,3v8 c0,1.6542969,1.3457031,3,3,3h12c1.6542969,0,3-1.3457031,3-3v-8C46,33.3457031,44.6542969,32,43,32z M34,29 c0-1.6542969,1.3457031-3,3-3s3,1.3457031,3,3v3h-6V29z M44,43c0,0.5517578-0.4487305,1-1,1H31c-0.5512695,0-1-0.4482422-1-1v-8 c0-0.5517578,0.4487305-1,1-1h12c0.5512695,0,1,0.4482422,1,1V43z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36,37 36,42 38,42 38,37 38,36 36,36  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorsLockedMedium);
export default __webpack_public_path__ + "static/media/doors-locked--medium.70af160de8ffe1225ecaeb0f97ab18f5.svg";
export { ForwardRef as ReactComponent };